export default __webpack_public_path__ + "static/media/Vector.56773610.svg";